import { render } from "./RouteByOptimal.vue?vue&type=template&id=4c5ee707&scoped=true"
import script from "./RouteByOptimal.vue?vue&type=script&lang=js"
export * from "./RouteByOptimal.vue?vue&type=script&lang=js"

import "./RouteByOptimal.vue?vue&type=style&index=0&id=4c5ee707&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1700309314/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c5ee707"]])

export default __exports__